import React from 'react';
import { Helmet } from 'react-helmet-async';
import './LegalPage.css';

const PrivacyPolicy = () => {
    return (
        <div className="legal-container">
            <Helmet>
                <title>Privacy Policy | RiyaMaga</title>
                <meta name="description" content="Learn how RiyaMaga collects, uses, and protects your personal information." />
            </Helmet>

            <div className="legal-header">
                <h1>Privacy Policy</h1>
                <p className="legal-updated">Last updated: February 2025</p>
            </div>

            <div className="legal-body">
                <section className="legal-section">
                    <h2>1. Information We Collect</h2>
                    <p>When you register or use RiyaMaga, we may collect the following information:</p>
                    <ul>
                        <li>Full name, email address, and phone number</li>
                        <li>Account type (Individual or Corporate) and business details</li>
                        <li>Ad listings including vehicle details, images, and pricing</li>
                        <li>Usage data such as pages visited and search queries</li>
                        <li>Device information and IP address for security purposes</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>2. How We Use Your Information</h2>
                    <p>We use the information we collect to:</p>
                    <ul>
                        <li>Create and manage your account</li>
                        <li>Display your ads to other users on the platform</li>
                        <li>Communicate with you about your listings and account activity</li>
                        <li>Improve our services and user experience</li>
                        <li>Prevent fraud and ensure platform security</li>
                        <li>Comply with legal obligations</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>3. Information Sharing</h2>
                    <p>We do <strong>not</strong> sell, trade, or rent your personal information to third parties. We may share information only in the following circumstances:</p>
                    <ul>
                        <li>With service providers who help us operate the platform (e.g., cloud storage, image hosting)</li>
                        <li>When required by law or to respond to legal processes</li>
                        <li>To protect the rights, property, or safety of RiyaMaga or our users</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>4. Data Security</h2>
                    <p>We implement industry-standard security measures including encryption, secure authentication, and regular security assessments to protect your data. However, no method of transmission over the internet is 100% secure.</p>
                </section>

                <section className="legal-section">
                    <h2>5. Cookies</h2>
                    <p>RiyaMaga uses cookies and similar technologies to enhance your experience, remember your preferences, and analyze site traffic. You may disable cookies in your browser settings, though some features may not function properly.</p>
                </section>

                <section className="legal-section">
                    <h2>6. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access and review the personal information we hold about you</li>
                        <li>Request correction of inaccurate data</li>
                        <li>Request deletion of your account and associated data</li>
                        <li>Opt-out of marketing communications</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>7. Changes to This Policy</h2>
                    <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page and updating the "Last updated" date.</p>
                </section>

                <section className="legal-section">
                    <h2>8. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                    <p><strong>Email:</strong> privacy@riyamaga.site</p>
                    <p><strong>Address:</strong> Colombo, Sri Lanka</p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
